import CheckCircle from "@uui/CheckCircle";
import XCircle from "@uui/XCircle";

import { titleize } from "@app/utils/utils";

import Button from "@rui/Button";
import { Link } from "@rui/Link";
import Stack from "@rui/Stack";

import { Container, DownloadProgress, ProgressText } from "./styles";

interface FileDownloadProps {
  title: string;
  loading: boolean;
  error: boolean;
  reportUrl: string;
}

const FileDownload = ({
  title,
  loading,
  error,
  reportUrl,
}: FileDownloadProps) => {
  return (
    <Container>
      {error ? (
        <>
          <ProgressText>
            Oops! Something went wrong and the {title} could not be generated.
          </ProgressText>
          <XCircle sx={{ color: "shades.negative.500" }} />
          <Button component={Link} to={reportUrl}>
            Go to Report
          </Button>
        </>
      ) : loading ? (
        <>
          <ProgressText>Generating {title}...</ProgressText>
          <Stack sx={{ height: "24px" }}>
            <DownloadProgress variant="indeterminate" />
          </Stack>
        </>
      ) : (
        <>
          <ProgressText>{titleize(title)} downloaded!</ProgressText>
          <CheckCircle sx={{ color: "shades.meadow.500" }} />
        </>
      )}
    </Container>
  );
};

export default FileDownload;
